import React from 'react';
import './faq.css';

const FAQ = () => {
    const faqs = [
        {
            question: "¿Qué es el AI Pricing Analytics Assistant?",
            answer: "Es una herramienta impulsada por inteligencia artificial que te ayuda a optimizar la estrategia de precios de tus productos, analizando ventas, márgenes, precios de la competencia y otros factores clave. Recuerda que los precios sugeridos son solo una guía y deben ser validados por el usuario final."
        },
        {
            question: "¿Qué tipo de datos se utilizan?",
            answer: "Utilizamos datos como la fecha de venta, identificadores de productos (SKU), unidades vendidas, precios finales, márgenes, y otros parámetros relacionados con la competencia y las ubicaciones geográficas."
        },
        {
            question: "¿Cómo se asegura la precisión de los precios recomendados?",
            answer: "El asistente utiliza modelos de machine learning que se entrenan constantemente con datos actualizados para ofrecer recomendaciones precisas y basadas en evidencia. Sin embargo, siempre debes validar las recomendaciones antes de implementarlas."
        },
        {
            question: "¿Cómo se protege la privacidad de mis datos?",
            answer: "La privacidad y seguridad de tus datos son nuestra prioridad. Estas se heredan de los SLA, reglas y políticas de seguridad de AWS y los servicios que utilizamos en la arquitectura del asistente, como S3, Lambda, PostgreSQL y Bedrock. Además, se manejan de acuerdo con las leyes y regulaciones vigentes, utilizando encriptación y otras medidas de seguridad avanzadas."
        },
        {
            question: "¿Puedo personalizar las recomendaciones de precios?",
            answer: "Sí, puedes ajustar los parámetros y criterios que utiliza el asistente para que las recomendaciones se adapten mejor a tus necesidades específicas. Aun así, los precios sugeridos deben ser validados antes de aplicarlos."
        }
    ];

    return (
        <div className="faq-container">
            <h1>Preguntas Frecuentes sobre AI Pricing Analytics Assistant</h1>
            <div className="faq-list">
                {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <h3 style={{ color: '#073C5C' }}>{faq.question}</h3>
                        <p>{faq.answer}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;